var sizeList = [];
var newSizeList = [];
function sortSizeList($selector, $container) {
  $selector.each(function (i, item) {
    sizeClothing = $(item).find("a").data("value");
    sizeFootwear = $(item).find("a").data("value");

    switch ((sizeClothing, sizeFootwear)) {
      //! Roupas
      case "2XP":
        item.setAttribute("data-id", "1");
        break;

      case "XP":
        item.setAttribute("data-id", "2");
        break;

      case "P":
        item.setAttribute("data-id", "3");
        break;

      case "M":
        item.setAttribute("data-id", "4");
        break;

      case "G":
        item.setAttribute("data-id", "5");
        break;

      case "GG":
        item.setAttribute("data-id", "6");
        break;

      case "2XG":
        item.setAttribute("data-id", "7");
        break;

      case "3XG":
        item.setAttribute("data-id", "8");
        break;

      //! Calçados
      case "32":
        item.setAttribute("data-id", "32");
        break;

      case "33":
        item.setAttribute("data-id", "33");
        break;

      case "34":
        item.setAttribute("data-id", "34");
        break;

      case "35":
        item.setAttribute("data-id", "35");
        break;

      case "36":
        item.setAttribute("data-id", "36");
        break;

      case "37":
        item.setAttribute("data-id", "37");
        break;

      case "38":
        item.setAttribute("data-id", "38");
        break;

      case "39":
        item.setAttribute("data-id", "39");
        break;

      case "40":
        item.setAttribute("data-id", "40");
        break;

      case "41":
        item.setAttribute("data-id", "41");
        break;

      case "42":
        item.setAttribute("data-id", "42");
        break;

      case "43":
        item.setAttribute("data-id", "43");
        break;

      case "44":
        item.setAttribute("data-id", "44");
        break;
    }
  });

  sizeList = $selector;
  newSizeList = [...new Set(sizeList)];

  newSizeList.sort(function (a, b) {
    return $(a).attr("data-id") - $(b).attr("data-id");
  });

  $container.html(newSizeList);
}

var $selector;
var $container;

$(document).ready(function () {
  setTimeout(() => {
    $selector = $(
      ".detail .product-form .selector-wrapper.is-size .swatch__container .clickyboxes.options--tamanho li"
    );
    $container = $(
      ".detail .product-form .selector-wrapper.is-size .swatch__container .clickyboxes.options--tamanho"
    );
    sortSizeList($selector, $container);
  }, 1000);
});

$(".quickbuy-toggle").on("click", function () {
  setTimeout(() => {
    var $parent = $(this)
      .parents(".container--not-mobile")
      .next()
      .children(".inner")
      .children(".product-detail")
      .find(".detail");
    $selector = $parent.find(
      ".product-form .selector-wrapper.is-size .swatch__container .clickyboxes#clickyboxes-SingleOptionSelector-1 li"
    );
    $container = $parent.find(
      ".product-form .selector-wrapper.is-size .swatch__container .clickyboxes#clickyboxes-SingleOptionSelector-1"
    );
    sortSizeList($selector, $container);
  }, 1000);
});
